module.exports = __webpack_public_path__ + "static/media/SushiTrain.54cf5a6a.jpg";